import { render, staticRenderFns } from "./club-courses.vue?vue&type=template&id=155031ec&scoped=true&"
import script from "./club-courses.vue?vue&type=script&lang=ts&"
export * from "./club-courses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155031ec",
  null
  
)

export default component.exports